import gql from 'graphql-tag';
import React, { useContext } from 'react';

import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';

import { SellFormContext } from '../../SellFormContext';
import { Section } from '../../sellFormViewSections';
import ShippingForm from '../shipping/ShippingForm';
import { ShippingProfilePricesPricesFragment } from '../../../ShippingSummary';

const COMPONENT_NAME = 'ShippingSection';

export const SellFormShopShippingFragment = gql`
  fragment SellFormShopShipping on Shop {
    _id
    currencySetting
    sameDayShippingConfigured
    shippingRegionSettings {
      regionCode
      regionName
      isDomestic
      allowedToShipCarrierCalculated
    }
    address {
      _id
      region
      postalCode
      countryCode
    }
    ...ShippingProfilePrices
  },
  ${ShippingProfilePricesPricesFragment}
`;

export function ShippingSection({ scrollRef }: { scrollRef: React.MutableRefObject<HTMLDivElement> }) {
  const { completionStatusMap, listingCreateFlow } = useContext(SellFormContext);

  const completionStatus = completionStatusMap[Section.SHIPPING];
  const { completed } = completionStatus;

  useViewTracking({
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ComponentView,
    listingCreateFlow,
  }, true);

  return <ShippingForm scrollRef={scrollRef} completed={completed} />;
}
